import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { _className } from '../../utils/tools.js';
import './TS_Printable.scss';
export class TS_Printable extends React.Component {
    ref;
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    render() {
        const { printable, printOnly, ...props } = this.props;
        return (_jsx("div", { ...props, className: _className('ts-printable', props.className, printOnly ? 'print-only' : undefined), ref: (async (ref) => {
                if (this.ref)
                    return;
                this.ref = ref;
                await printable(this.ref);
                this.forceUpdate();
            }), children: this.props.children }));
    }
}
//# sourceMappingURL=TS_Printable.js.map